import styled from 'styled-components'

const ButtonGroup = styled.div`
  display: flex;
  margin-top: 10px;
`

export default ButtonGroup
